import styled from 'styled-components'

const HeadlineWrap = styled.div<{ $isSticky?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-flow: row nowrap;
  align-items: ${props => (props.$isSticky ? 'flex-start' : 'baseline')};
  gap: 40px;
  min-width: 880px;

  /* Keep page title aligned with the date-control button row (Default / 7 days / 30 days / Custom). */
  & > div:first-child {
    flex-shrink: 0;
  }

  ${props =>
    props.$isSticky &&
    `
    padding: 16px 28px 16px 40px;
    position: sticky;
    top: 0;
    background-color: var(--color-selago-grey);
    z-index: 11;
  `}
`

const Container = styled.div`
min-width: fit-content;
`

export { HeadlineWrap, Container }
